var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user == null)?_c('div',{staticClass:"search"},[_c('JobOffersSection',{staticClass:"search_recent",attrs:{"jobs":_vm.foundJobs}},_vm._l((_vm.terms),function(t){return _c('span',{key:t,domProps:{"textContent":_vm._s(t)}})}),0)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }